export default __webpack_public_path__ + "static/media/timer-icon.76ac590f.svg";